<template>
  <div>
    <ReviewsFilterModal
      ref="reviewsFilterModal"
      :handleAnswer="handleAnswer"
      :type="filterType"
    />
    <div class="shadow-card top-card">
      <div v-if="type" class="mb-3">
        <span
          @click="handleBack"
          :style="{ color: getPrimaryColor(), cursor: 'pointer' }"
        >
          <font-awesome-icon
            class="mr-2"
            :style="{ color: getPrimaryColor() }"
            :icon="['fas', 'arrow-left']"
          />
          Back</span
        >
      </div>
      <h3 class="top-title">
        {{
          type
            ? `${
                type === "ohcp"
                  ? "Advanced Practice Provider"
                  : type.charAt(0).toUpperCase() + type.slice(1)
              } `
            : ""
        }}Reviews
      </h3>
      <div class="top-middle-content">
        <div class="top-input-container">
          <font-awesome-icon
            :icon="['fal', 'search']"
            :style="{ color: getPrimaryColor(), width: '20px' }"
            class="cp ml-3"
            @click="() => handleSubmit(1)"
          />
          <a-input
            type="search"
            class="search-field"
            placeholder="Search by name"
            :value="searchKey"
            @change="handleSearch"
            @input="callDebounce"
            @keyup.enter="() => handleSubmit(1)"
          >
          </a-input>
          <a-icon
            v-if="searchKey"
            class="close-icon"
            type="close"
            :size="'large'"
            @click="clearSearch"
          />
        </div>
        <button
          v-if="type === 'ohcp' || type === 'physician'"
          class="search-button position-relative"
          @click="$refs.reviewsFilterModal.show()"
        >
          <img
            src="../../../assets/images/filter_icon.svg"
            alt="filter"
            height="14px"
            width="18px"
          /><span class="filter-text">Apply Filters</span>
          <div
            class="active-filter-indicator"
            :style="{ background: getPrimaryColor() }"
          />
        </button>
      </div>
      <div v-if="type === 'ohcp' || type === 'physician'" class="top_filters">
        <div class="filter-container">
          <div class="appliedFilter">Applied Filter:</div>
          <div class="filterTypeBox">
            <div class="filterTypeText">{{ getFilterType() }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-container">
      <div v-for="review_for in !type ? reviews_all_types : [`${type}`]">
        <p v-if="!type" class="sub_heading">
          {{
            review_for === "ohcp"
              ? "Advanced Practice Provider"
              : review_for.charAt(0).toUpperCase() + review_for.slice(1)
          }}
          reviews
        </p>
        <div
          v-if="
            type &&
              !$data[`${review_for}_loading`] &&
              ((filterType === 'InPerson' &&
                $data[`core_${review_for}_reviews`].hasOwnProperty('results') &&
                $data[`core_${review_for}_reviews`].results.length !== 0) ||
                (filterType !== 'InPerson' && my_circle_total_count !== 0))
          "
          class="page-info sort-dropdown"
        >
          <p v-if="filterType === 'InPerson'" class="result-length">
            {{ $data[`core_${review_for}_reviews`].count
            }}{{
              $data[`core_${review_for}_reviews`].count > 1
                ? " Results"
                : " Result"
            }}
          </p>
          <p v-else class="result-length">
            {{ my_circle_total_count
            }}{{ my_circle_total_count > 1 ? " Results" : " Result" }}
          </p>
          <a-dropdown
            style="margin-top: 7px"
            :trigger="['click']"
            :getPopupContainer="trigger => trigger.parentNode"
          >
            <p class="sort-text">
              Show
              <span style="font-weight: 700">{{ sortList[sortKey] }}</span>
              <font-awesome-icon
                size="lg"
                style="margin-left: 8px"
                :icon="['fas', 'angle-down']"
              />
            </p>
            <template #overlay>
              <a-menu @click="e => sortReviews(e.key)">
                <a-menu-item key="-published">Newest First</a-menu-item>
                <a-menu-item key="published">Oldest First</a-menu-item>
                <a-menu-item key="-overall">Highest Rated First</a-menu-item>
                <a-menu-item key="nearest">Nearest To You</a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
        <div
          v-if="$data[`${review_for}_loading`]"
          class="d-flex justify-content-center mt-3"
        >
          <div>
            <div class="spinner-border position-absolute spinner-class"></div>
          </div>
          <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">
            Loading...
          </div>
        </div>
        <ReviewTabCoreCard
          v-if="
            !$data[`${review_for}_loading`] &&
              filterType === 'InPerson' &&
              $data[`core_${review_for}_reviews`].hasOwnProperty('results') &&
              $data[`core_${review_for}_reviews`].results.length !== 0 &&
              (type ? true : index < 3)
          "
          v-for="(review, index) in $data[`core_${review_for}_reviews`].results"
          :reviewData="review"
          :type="review_for"
          :key="review.id"
          :showAllreviewsButton="true"
        />
        <div
          v-if="
            !$data[`${review_for}_loading`] &&
              $data[`core_${review_for}_reviews`].hasOwnProperty('results') &&
              $data[`core_${review_for}_reviews`].results.length !== 0 &&
              $data[`core_${review_for}_reviews`].results.length > 3 &&
              !type
          "
          class="view_more"
          @click="() => handleViewAllReviews(review_for)"
        >
          View
          {{
            $data[`core_${review_for}_reviews`].count -
              3 +
              $data[`my_circle_${review_for}_count`]
          }}
          more
          {{ review_for === "ohcp" ? "practice provider" : review_for }}
          reviews
          <font-awesome-icon
            size="2x"
            class="mr-2"
            :style="{
              transform: 'scale(0.6)',
              width: '30px'
            }"
            :icon="['fa', 'arrow-right']"
          />
        </div>
        <p
          v-if="
            !$data[`${review_for}_loading`] &&
            $data[`core_${review_for}_reviews`].hasOwnProperty('results')
              ? !$data[`core_${review_for}_reviews`].results.length
              : !$data[`core_${review_for}_reviews`]
          "
          class="empty_board"
        >
          No
          {{
            review_for === "ohcp"
              ? "Advanced Practice Provider"
              : review_for.charAt(0).toUpperCase() + review_for.slice(1)
          }}
          reviews
        </p>
        <!-- My circle reviews card -->
        <ReviewTabCard
          v-if="
            filterType !== 'InPerson' &&
              !$data[`${review_for}_loading`] &&
              my_circle_reviews.length
          "
          v-for="review in my_circle_reviews"
          :key="review.id"
          :reviewData="review"
          :showAllreviewsButton="true"
          :isProfile="false"
        />
        <p
          v-if="
            !$data[`${review_for}_loading`] &&
              type &&
              filterType !== 'InPerson' &&
              my_circle_total_count === 0
          "
          class="empty_board"
        >
          No
          {{
            review_for === "ohcp"
              ? "Advanced Practice Provider"
              : review_for.charAt(0).toUpperCase() + review_for.slice(1)
          }}
          {{ getFilterType() }}
          reviews
        </p>
      </div>
      <!-- Core reviews pagination -->
      <div
        v-if="
          !$data[`${type}_loading`] &&
            type &&
            filterType === 'InPerson' &&
            $data[`core_${type}_reviews`].results.length &&
            $data[`core_${type}_reviews`].count > page_size
        "
        :style="{
          padding: '30px',
          display: 'flex',
          justifyContent: 'center'
        }"
      >
        <a-pagination
          v-model="currentPage"
          class="dovemed-custom-pagination"
          :total="$data[`core_${type}_reviews`].count"
          show-less-items
          :pageSize="page_size"
          @change="handlePagination"
        />
      </div>
      <!-- My circle reviews pagination -->
      <div
        v-if="
          !$data[`${type}_loading`] &&
            type &&
            filterType !== 'InPerson' &&
            my_circle_total_count > page_size
        "
        :style="{
          padding: '30px',
          display: 'flex',
          justifyContent: 'center'
        }"
      >
        <a-pagination
          v-model="currentPage"
          class="dovemed-custom-pagination"
          :total="my_circle_total_count"
          show-less-items
          :pageSize="page_size"
          @change="fetchMyCircleReviews"
        />
      </div>
    </div>
    <div class="p-5"></div>
  </div>
</template>

<script>
import ReviewsFilterModal from "../../Modals/ReviewsFilterModal.vue";
import ReviewTabCoreCard from "./ReviewTabCoreCard.vue";
import ReviewTabCard from "./ReviewTabCard.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFilter } from "@fortawesome/pro-solid-svg-icons";
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";

const ReviewsRepository = RepositoryFactory.get("reviews");
library.add(faFilter);

export default {
  name: "Reviews",

  components: {
    ReviewsFilterModal,
    ReviewTabCoreCard,
    ReviewTabCard
  },

  data() {
    return {
      reviews: null,
      core_clinic_reviews: {},
      core_hospital_reviews: {},
      core_physician_reviews: {},
      core_ohcp_reviews: {},
      sortKey: "-published",
      sortList: {
        "-published": "Newest First",
        published: "Oldest First",
        "-overall": "Highest Rated First",
        nearest: "Nearest To You"
      },
      currentPage: 1,
      clinic_loading: true,
      hospital_loading: true,
      physician_loading: true,
      ohcp_loading: true,
      filterType: "InPerson",
      searchKey: "",
      type: undefined,
      reviews_all_types: ["physician", "ohcp", "clinic", "hospital"],
      page_size: 10,
      my_circle_physician_count: 0,
      my_circle_ohcp_count: 0,
      my_circle_clinic_count: 0,
      my_circle_hospital_count: 0,
      my_circle_reviews: [],
      my_circle_total_count: 0
    };
  },

  watch: {
    "$route.query.type": {
      handler() {
        if (this.$route.query.type === undefined) {
          this.type = undefined;
          this.searchKey = "";
          this.sortKey = "-published";
          this.filterType = "InPerson";
          this.handleSubmit();
        }
      }
    },
    filterType: {
      handler() {
        this.handlePathQuery("filterType");
      }
    },
    type: {
      handler() {
        this.handlePathQuery("type");
      }
    },
    sortKey: {
      handler() {
        this.handlePathQuery("sortKey");
      }
    },
    currentPage: {
      handler() {
        this.handlePathQuery("currentPage");
      }
    }
  },
  mounted() {
    this.setVariablesFromQuery();
    this.handleSubmit(this.page);
  },
  methods: {
    setVariablesFromQuery() {
      Object.keys(this.$route.query).forEach(key => {
        if (this.$route.query[key]) {
          this[key] = this.$route.query[key];
        }
      });
    },
    handlePathQuery(v) {
      this.$router
        .replace({
          ...this.$route,
          query: {
            ...this.$route.query,
            [v]: this[v]
          }
        })
        .catch(e => {});
    },
    handleBack() {
      this.$router.push({ name: "Reviews" });
      this.filterType = "InPerson";
    },
    handleViewAllReviews(type) {
      this.type = type;
    },
    handleSearch(e) {
      this.searchKey = e.target.value;
    },
    handleSubmit(page = 1) {
      this.handlePathQuery("searchKey");
      this.currentPage = page;
      if (this.type) {
        if (this.filterType === "InPerson") {
          this.handlePagination();
        } else {
          this.fetchMyCircleReviews();
        }
      } else {
        //core reviews
        this.fetchCoreReviews("physician");
        this.fetchCoreReviews("ohcp");
        this.fetchCoreReviews("clinic");
        this.fetchCoreReviews("hospital");
        //MyCircle reviews count
        this.fetchMyCircleReviewsCount("doctor");
        this.fetchMyCircleReviewsCount("hcp");
      }
    },
    handlePagination() {
      this.fetchCoreReviews(this.type);
    },
    callDebounce: _.debounce(function() {
      this.handleSubmit();
    }, 500),
    clearSearch() {
      this.searchKey = "";
      this.currentPage = 1;
      this.handleSubmit();
    },
    sortReviews(sort) {
      this.sortKey = sort;
      this.handleSubmit(this.page);
    },
    fetchMyCircleReviewsCount(type = "doctor") {
      ReviewsRepository.getReviews(
        this.currentCircle.id,
        1,
        1,
        type,
        "",
        this.searchKey,
        this.getSortKey()
      )
        .then(res => {
          if (res.data.data.hasOwnProperty("paginator")) {
            this.$data[
              `my_circle_${type === "doctor" ? "physician" : "ohcp"}_count`
            ] = parseInt(res.data.data.paginator.total_count);
          }
        })
        .catch(err => {
          this.$data[
            `my_circle_${type === "doctor" ? "physician" : "ohcp"}_count`
          ] = 0;
        });
    },
    fetchMyCircleReviews() {
      this.$data[`${this.type}_loading`] = true;
      document.body.scrollTop = 0;
      ReviewsRepository.getReviews(
        this.currentCircle.id,
        this.currentPage,
        this.page_size,
        this.type === "physician" ? "doctor" : "hcp",
        this.type === "physician" || this.type === "ohcp"
          ? this.filterType
          : "",
        this.searchKey,
        this.getSortKey()
      )
        .then(res => {
          if (res.data.data.hasOwnProperty("data")) {
            this.my_circle_reviews = res.data.data.data;
            this.my_circle_total_count = parseInt(
              res.data.data.paginator.total_count
            );
          } else {
            this.my_circle_reviews = [];
            this.my_circle_total_count = 0;
          }
          this.$data[`${this.type}_loading`] = false;
        })
        .catch(err => {
          this.$data[`${this.type}_loading`] = false;
        });
    },
    fetchCoreReviews(review_for) {
      this.$data[`${review_for}_loading`] = true;
      document.body.scrollTop = 0;
      const headers = {
        Authorization: `Basic ${btoa("dovemed:dovemed-rules")}`,
        dtoken:
          this.authUser.user.dovemed_csrf_token ||
          this.authUser.user.dovemed_session_token
      };
      ReviewsRepository.getCoreReviews(
        headers,
        review_for,
        this.currentPage,
        this.searchKey,
        this.sortKey,
        this.page_size
      )
        .then(res => {
          if (res.data.results.length) {
            this.$data[`core_${review_for}_reviews`] = res.data;
          } else {
            this.$data[`core_${review_for}_reviews`]["results"] = [];
          }
          this.$data[`${review_for}_loading`] = false;
        })
        .catch(err => {
          this.$data[`core_${review_for}_reviews`]["results"] = [];
          this.$data[`${review_for}_loading`] = false;
        });
    },
    handleAnswer(type = "") {
      this.filterType = type;
      this.handleSubmit();
    },
    getFilterType() {
      if (this.filterType === "InPerson") {
        return "In Person Visit";
      } else if (this.filterType === "MyCircles") {
        return "MyCircles Interaction";
      } else if (this.filterType === "Online") {
        return "Online Telemedicine";
      }
    },
    getSortKey() {
      if (this.sortKey === "-published") {
        return "Newest";
      } else if (this.sortKey === "published") {
        return "Oldest";
      } else if (this.sortKey === "-overall") {
        return "Rating";
      } else if (this.sortKey === "nearest") {
        return "Nearest";
      }
    }
  }
};
</script>

<style lang="scss">
.dovemed-custom-pagination .ant-pagination-item-active {
  background: #2a71d4;
}

.dovemed-custom-pagination .ant-pagination-item-active a {
  color: #ffffff !important ;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
}

.dovemed-custom-pagination .ant-pagination-item-active a:hover {
  color: #ffffff !important;
}
</style>

<style lang="scss" scoped>
.mobile-filters {
  @media only screen and (min-width: 767px) {
    display: none;
  }
  padding: 24px;
  -webkit-box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.1);
  box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.1);
  .page-title {
    display: flex;
    margin-top: 0px;
    margin-bottom: 24px;
    font-size: 32px;
    font-weight: 700;
    color: #0f1734;
  }
  .filter-container::-webkit-scrollbar {
    display: none;
  }
  .filter-container {
    display: flex;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    margin-bottom: 24px;
    .button-container {
      cursor: pointer;
      width: fit-content;
      margin-right: 16px;
      position: relative;
      .button {
        padding: 12px 24px;
        border-radius: 6px;
        border: none;
        white-space: nowrap;
        font-weight: 700;
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
  .review-type {
    margin-bottom: 24px;
    .sub-heading {
      font-weight: 700;
      font-size: 16px;
      line-height: 32px;
      color: #0f1734;
      margin-bottom: 8px;
    }
    .filter-item {
      font-weight: 400;
      font-size: 14px;
      color: #1e2945;
      display: flex;
      align-items: center;
      margin-bottom: 16px;
    }
  }
}
.top-card {
  margin-bottom: 20px;
  @media only screen and (max-width: 700px) {
    padding: 24px;
    -webkit-box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.1);
    box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.1);
    margin: 0px;
  }
  .top-title {
    display: flex;
    margin-top: 0px;
    margin-bottom: 24px;
    font-size: 32px;
    font-weight: 700;
    color: #0f1734;
  }
  .top-middle-content {
    @media screen and (min-width: 701px) {
      display: flex;
    }
  }
  .top-input-container {
    display: flex;
    background: #f1f5f9;
    border-radius: 8px;
    height: 60px;
    width: 100%;
    align-items: center;
    .search-field {
      background: #f1f5f9;
      border-radius: 8px;
      border: none;
      height: 60px;
      width: 100%;
    }
    .close-icon-size {
      font-size: 15px;
    }
  }
  .search-button {
    width: 60px;
    height: 60px;
    background: #f1f5f9;
    border-radius: 8px;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 24px;
    @media screen and (max-width: 700px) {
      width: 100%;
      margin-top: 16px;
      margin-left: 0px;
    }
    .active-filter-indicator {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      align-self: flex-start;
      margin-top: 18px;
      margin-left: 5px;
      @media screen and (min-width: 701px) {
        top: 0;
        right: 0;
        position: absolute;
        margin-right: 10px;
        margin-top: 15px;
      }
    }
  }
  .top_filters {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
    @media screen and (max-width: 700px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  .filter-container {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
  }
  .filter-text {
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    color: #0f1734;
    margin-left: 16px;
    @media screen and (min-width: 701px) {
      display: none;
    }
  }
  .appliedFilter {
    font-weight: 700;
    font-size: 14px;
    color: #647490;
    line-height: 24px;
  }

  .filterTypeBox {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    gap: 8px;
    background: #f1f5f9;
    border-radius: 6px;

    .filterTypeText {
      font-weight: 700;
      font-size: 14px;
      color: #0f1734;
    }
  }
  .clear-filter {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    cursor: pointer;
    white-space: nowrap;
    @media screen and (max-width: 700px) {
      margin-top: 16px;
      align-self: center;
    }
  }
}
.search-container {
  display: flex;
}

.search-field {
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
  margin-right: 24px;
  height: 60px;
}

.search-button {
  width: 60px;
  height: 60px;
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
}
.top_filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  @media screen and (max-width: 700px) {
    display: none;
  }
}
.applied-filter-container {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}
.appliedFilter {
  font-weight: 700;
  font-size: 14px;
  color: #647490;
  line-height: 24px;
}

.filterTypeBox {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  gap: 8px;
  background: #f1f5f9;
  border-radius: 6px;

  .filterTypeText {
    font-weight: 700;
    font-size: 14px;
    color: #0f1734;
  }
}
.clear-filter {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
}

.page-container {
  @media only screen and (max-width: 767px) {
    padding: 16px;
    padding-top: 0px;
  }
}
.page-info {
  margin-top: 48px;
  margin-bottom: 24px;
  @media only screen and (max-width: 767px) {
    margin-top: 24px;
    margin-bottom: 16px;
  }
  display: flex;
  justify-content: space-between;
}

.result-length-mobile {
  font-weight: 700;
  font-size: 20px;
  color: #0f1734;
  margin-bottom: 0px;
  @media only screen and (min-width: 767px) {
    display: none;
  }
}

.result-length {
  font-weight: 700;
  font-size: 20px;
  color: #0f1734;
  margin-bottom: 0px;
}

.sort-text {
  font-weight: 400;
  font-size: 14px;
  color: #0f1734;
  margin-bottom: 0px;
  cursor: pointer;
  white-space: nowrap;
  margin-left: 20px;
}
.sub_heading {
  color: #0f1734;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  padding-top: 20px;
}
.empty_board {
  padding: 16px;
  border-radius: 8px;
  background: #f1f5f9;
  color: #94a3b8;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  margin-top: 20px;
}
.view_more {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 8px;
  background: #f1f5f9;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  cursor: pointer;
  color: #47556e;
}
</style>



// WEBPACK FOOTER //
// src/components/home/reviews/Reviews.vue